import { useState, useEffect } from 'react';

import { MenuItemType } from '../types/menu-item';
import getPinnedApps from '../utils/pinnedApps';

import { useGetPremiumRoutes } from './useGetPremiumRoutes';

const useUpdatePinnedApps = (): MenuItemType[] => {
  const [pinnedApps, setPinnedApps] = useState<MenuItemType[]>([]);
  const premiumRoutes = useGetPremiumRoutes();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    setPinnedApps(getPinnedApps(premiumRoutes));
    const handlePinnedAppsChange = () => {
      setPinnedApps(getPinnedApps(premiumRoutes));
    };

    window.addEventListener('pinnedAppsChanged', handlePinnedAppsChange);

    return () => {
      window.removeEventListener('pinnedAppsChanged', handlePinnedAppsChange);
    };
  }, []);

  return pinnedApps;
};

export default useUpdatePinnedApps;
